import { TEDFormatTime } from '../../../Utils/Formatters/FormatterClasses/TEDFormatTime';
import { ParseResult } from '../../../Utils/Formatters/FormatterTypes';

export const getTryParseTime =
  (formatter: TEDFormatTime, parseParams?: string) => (text: string | null) => {
    const res = formatter.parser.parse(text || '', parseParams);
    if (res.result === ParseResult.OK) {
      return formatter.displayer.display(res.value, true);
    } else {
      return undefined;
    }
  };
